import { GetClaimStatsParams } from './get-claim-stats';
import { GetLeaderboardParams } from './get-current-leaderboard';
import { GetPreSeasonLeaderboardParams } from './get-preseason-leaderboard';
import { GetUserPointParams } from './get-user-points';
import { GetUserScoreParams } from './get-user-score';
import { GetXPLeaderboardParams } from './get-xp-leaderboard';

export const leaderboardKeys = {
  all: ['leaderboard'] as const,
  getCurrentLeaderboard: (params: GetLeaderboardParams) =>
    [
      ...leaderboardKeys.all,
      'getCurrentLeaderboard',
      params.page,
      params.page_size,
      params.sort_by,
      params.sort_order,
      params.useraddress,
    ] as const,
  getPreviousLeaderboard: () => [...leaderboardKeys.all, 'getPreviousLeaderboard'] as const,
  getPreseasonLeaderboard: (params: GetPreSeasonLeaderboardParams) =>
    [
      ...leaderboardKeys.all,
      'getPreseasonLeaderboard',
      params.page,
      params.page_size,
      params.user,
    ] as const,

  getUserPoints: (params: GetUserPointParams) =>
    [
      ...leaderboardKeys.all,
      'getUserPoints',
      params.walletAddress,
      params.end_date,
      params.start_date,
    ] as const,
  getUserScore: (params: GetUserScoreParams & { address?: string }) =>
    [...leaderboardKeys.all, 'getUserScore', params.from, params.to, params.address] as const,
  getLeaderboardById: (id: string, params: GetLeaderboardParams, userAddress?: string) =>
    [
      ...leaderboardKeys.all,
      'getCurrentLeaderboard',
      id,
      params.page,
      params.page_size,
      userAddress,
    ] as const,

  getAllTimeLeaderboard: (params: GetLeaderboardParams) =>
    [
      ...leaderboardKeys.all,
      'getAllTimeLeaderboard',
      params.page,
      params.page_size,
      params.sort_by,
      params.sort_order,
      params.useraddress,
    ] as const,

  getClaimStats: (params: GetClaimStatsParams) =>
    [...leaderboardKeys.all, 'getClaimStats', params.end_date, params.start_date] as const,

  getXPLeaderboardParams: (params: GetXPLeaderboardParams) =>
    [
      ...leaderboardKeys.all,
      'getXPLeaderboardParams',
      params.page,
      params.page_size,
      params.start_date,
      params.end_date,
      params.useraddress,
    ] as const,
};
